import React, { useState } from "react";
import { Check, CheckCheck, Reply, Forward, Pencil, Trash2, Timer, Download, Phone } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const mediaUrl = (url) => `${BACKEND}${url}`;

/** Burbuja de chat de vidrio, con pulso rojo al llegar. */
export const MessageBubble = ({ msg, me, people, onReply, onForward, onEdit, onDelete, isNew }) => {
  const mine = msg.sender === me;
  const author = people?.[msg.sender];
  const [menu, setMenu] = useState(false);
  const read = (msg.read_by || []).some((k) => k !== msg.sender);

  return (
    <div className={`flex ${mine ? "justify-end" : "justify-start"}`} data-testid={`msg-${msg.msg_id}`}>
      <div className={`max-w-[78%] sm:max-w-[65%] group`}>
        {!mine && author && (
          <div className="text-[11px] text-white/45 mb-0.5 ml-1">{author.name}</div>
        )}
        <div onDoubleClick={() => setMenu((v) => !v)}
          className={`chat-bubble ${mine ? "chat-bubble-mine" : ""} ${isNew ? "bubble-arrive" : ""} px-3.5 py-2.5`}>
          {msg.reply_preview && (
            <div className="border-l-2 border-red-400/70 pl-2 mb-1.5 text-[11px] text-white/55">
              {people?.[msg.reply_preview.sender]?.name || "Miembro"}: {msg.reply_preview.text}
            </div>
          )}
          {msg.forward_of && <div className="text-[10px] text-white/40 italic mb-1">reenviado</div>}

          {msg.deleted ? (
            <div className="text-sm text-white/40 italic">Mensaje eliminado</div>
          ) : (
            <>
              {msg.media && msg.media.mime?.startsWith("image/") && (
                <img src={mediaUrl(msg.media.url)} alt={msg.media.name}
                  className="rounded-lg max-h-72 mb-1.5 border border-white/10" />
              )}
              {msg.media && msg.media.mime?.startsWith("video/") && (
                <video src={mediaUrl(msg.media.url)} controls
                  className="rounded-lg max-h-72 mb-1.5 border border-white/10" />
              )}
              {msg.media && msg.media.mime?.startsWith("audio/") && (
                <audio src={mediaUrl(msg.media.url)} controls className="mb-1.5 w-56" />
              )}
              {msg.media && !/^(image|video|audio)\//.test(msg.media.mime || "") && (
                <a href={mediaUrl(msg.media.url)} target="_blank" rel="noreferrer"
                  className="flex items-center gap-2 text-sm text-red-300 underline mb-1.5">
                  <Download className="w-3.5 h-3.5" /> {msg.media.name}
                </a>
              )}
              {msg.text && <div className="text-sm text-white whitespace-pre-wrap break-words">
                {msg.kind === "call" && <Phone className="w-3.5 h-3.5 inline mr-1.5 text-red-300" />}
                {msg.text}
              </div>}
            </>
          )}

          <div className="flex items-center justify-end gap-1 mt-1 text-[10px] text-white/40">
            {msg.expires_at && <Timer className="w-3 h-3 text-red-300" />}
            {msg.edited_at && <span>editado</span>}
            <span>{(msg.created_at || "").slice(11, 16)}</span>
            {mine && (read ? <CheckCheck className="w-3.5 h-3.5 text-red-300" /> : <Check className="w-3.5 h-3.5" />)}
          </div>
        </div>

        {menu && !msg.deleted && (
          <div className="flex gap-1 mt-1 flex-wrap" data-testid={`msg-actions-${msg.msg_id}`}>
            <button onClick={() => { onReply(msg); setMenu(false); }} className="glass-btn px-2 py-1 rounded-lg text-[11px] flex items-center gap-1"><Reply className="w-3 h-3" /> Responder</button>
            <button onClick={() => { onForward(msg); setMenu(false); }} className="glass-btn px-2 py-1 rounded-lg text-[11px] flex items-center gap-1"><Forward className="w-3 h-3" /> Reenviar</button>
            {mine && msg.text && (
              <button onClick={() => { onEdit(msg); setMenu(false); }} className="glass-btn px-2 py-1 rounded-lg text-[11px] flex items-center gap-1"><Pencil className="w-3 h-3" /> Editar</button>
            )}
            <button onClick={() => { onDelete(msg); setMenu(false); }} className="glass-btn px-2 py-1 rounded-lg text-[11px] flex items-center gap-1 text-rose-300"><Trash2 className="w-3 h-3" /> Eliminar</button>
          </div>
        )}
        {!menu && (
          <div className={`text-[10px] text-white/25 mt-0.5 ${mine ? "text-right" : ""} opacity-0 group-hover:opacity-100 transition-opacity`}>
            doble clic para opciones
          </div>
        )}
      </div>
    </div>
  );
};

export default MessageBubble;
